import { useEffect, useState } from 'react';
import logo from '../../assets/logo.png';
import {
  requestOtp,
  enableGuestMode,
  setLoginReturnPath,
  getLoginReturnPath,
  consumeLoginReturnPath,
} from '../../services/auth';
import { userExists } from '../../services/identity';
import { useLanguage } from '../../context/LanguageContext';

const LoginPage = () => {
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const nextParam = params.get('next');
    if (nextParam) {
      setLoginReturnPath(nextParam);
    } else if (!getLoginReturnPath()) {
      setLoginReturnPath('/');
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus(null);
    const trimmed = phone.trim();
    if (!trimmed) {
      setStatus(t('login.missing_phone'));
      return;
    }
    setSubmitting(true);
    try {
      const lookup = await userExists(trimmed);
      if (!lookup?.status) {
        setStatus(t('login.account_not_found'));
        setSubmitting(false);
        return;
      }
      const otpResult = await requestOtp(trimmed);
      if (otpResult.success) {
        setStatus(t('login.otp_sent'));
        window.location.assign('/otp');
      } else {
        setStatus(otpResult.message || t('login.otp_failed'));
      }
    } catch (error) {
      setStatus(error.message || t('login.otp_failed'));
    }
    setSubmitting(false);
  };

  return (
    <div className="login">
      <div className="login__content">
        <img src={logo} alt="Wassini logo" className="login__logo" />
        <h1 className="login__title">{t('login.title')}</h1>
        <form className="login__form" onSubmit={handleSubmit}>
          <label>
            <span>{t('login.phone_label')}</span>
            <input
              type="tel"
              name="phone"
              placeholder={t('login.phone_placeholder')}
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
            />
          </label>
          {status && <p className="login__status">{status}</p>}
          <button
            type="submit"
            className="button button--primary login__submit"
            disabled={submitting}
          >
            {submitting ? t('login.sending') : t('login.send_otp')}
          </button>
        </form>
        <p className="login__signup">
          {t('login.no_account')}{' '}
          <a href="/signup" className="login__signup-link">
            {t('login.signup')}
          </a>
        </p>
        <button
          type="button"
          className="login__guest"
          onClick={() => {
            enableGuestMode();
            const target = consumeLoginReturnPath() || '/';
            window.location.assign(target);
          }}
        >
          {t('login.continue_guest')}
        </button>
        <p className="login__powered">
          {t('login.powered')} <span>Softwarezz</span>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
